// extracted by mini-css-extract-plugin
export var content = "styles-module--content--c89d7";
export var narrow = "styles-module--narrow--553f4";
export var wide = "styles-module--wide--9dca2";